import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: "/prod-api",
    // baseURL: "/dev-api",     //测试
    // 超时
    timeout: 30000
})
// request拦截器
service.interceptors.request.use(config => {
    if (localStorage.getItem("token")) {
        config.headers['Authorization'] = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImYzZTZhMmNkLTkxNDQtNDdkYi1hNDZmLTM1YTEyMjc5NDU2OCJ9.SgcLdyNA22V_YVMBwIezymWT50T50XFW6XXO7OonjwbphJd8CoEqg6jMwZaU5GsXNcaQfcAm530JInl5VQuwsQ"
    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    var data=res.data
    if(data.code==200){
        return data
    }else{
        return Promise.reject(data)
    }

},
    error => {
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js